/* eslint no-bitwise: 0 */

/* Must match GoFormz.Common.Services.Core/GoFormz.Common.Services.Core/Enums/Permission.cs */
export const enum Operations {
  Read = 1,
  ReadAll = 2,
  ViewReports = 11,
  CanLoginToManagment = 12, // Not used, should be removed from all repos
  ViewTemplates = 13,
  PublicShare = 14,
  FormCopy = 15,
  FormRename = 16,
  FormTransfer = 17,
  FormDelete = 18,
  FormEdit = 19,
  FormComplete = 20,
  FormDeleteDrafts = 21,
  FormDownloadPDF = 22,
  FormTags = 23,
  TagCreate = 24,
  TagManage = 25,
  ManageDataSources = 26,
  ManageWorkflows = 27,
  ManageUsersGroups = 28
}

export enum Settings {
  SkipDashboard = 'skipDashboard',
  SkipPublishedTemplatePrompt = 'skipPublishedTemplatePrompt',
  SkipAddTemplateFieldsModal = 'skipAddTemplateFieldsModal',
  ExportDelimiter = 'exportDelimiter',
  ExportNewlines = 'exportNewlines',
  ExportTimezone = 'exportTimezone',
  ExportDateFormat = 'exportDateFormat'
}

export const enum Features {
  AccountUserList = 'AccountUserList',
  AddOns = 'AddOns',
  AdvancedFieldManagement = 'AdvancedFieldManagement',
  AiTemplateBuilder = 'AiTemplateBuilder',
  AllowAdminsToChangePasswords = 'AllowAdminsToChangePasswords',
  ApiDatasourcesReadAccess = 'ApiDatasourcesReadAccess',
  ApiDatasourcesWriteAccess = 'ApiDatasourcesWriteAccess',
  ApiReadAccess = 'ApiReadAccess',
  ApiWriteAccess = 'ApiWriteAccess',
  AttachFilesMaxNumber = 'AttachFilesMaxNumber',
  AttachFilesMaxSize = 'AttachFilesMaxSize',
  AttachFilesToForms = 'AttachFilesToForms',
  AudioField = 'AudioField',
  AudioFieldMaxLength = 'AudioFieldMaxLength',
  AutomatedTesting = 'AutomatedTesting',
  AutoTag = 'AutoTag',
  Barcode = 'Barcode',
  BrowserPdfProcessing = 'BrowserPdfProcessing',
  ChooseJourney = 'ChooseJourney',
  ConnectedApps = 'ConnectedApps',
  CTPFlow = 'CTPFlow',
  CustomActionDeepLink = 'CustomActionDeepLink',
  CustomActionHPMeasure = 'CustomActionHPMeasure',
  CustomActionWebView = 'CustomActionWebView',
  CustomActionWorkflowTrigger = 'CustomActionWorkflowTrigger',
  CustomSSO = 'CustomSSO',
  CustomUserAttributes = 'CustomUserAttributes',
  DarkMode = 'DarkMode',
  DateTimeDefaultValue = 'DateTimeDefaultValue',
  DisableAutoEmail = 'DisableAutoEmail',
  DisableEmailLinks = 'DisableEmailLinks',
  DisableTextLinks = 'DisableTextLinks',
  DisableOnboardingNavigation = 'DisableOnboardingNavigation',
  DisableSuccessLauncher = 'DisableSuccessLauncher',
  DisableTakeOwnership = 'DisableTakeOwnership',
  PremiumDataSources = 'PremiumDataSources',
  PremiumPerDataSource = 'PremiumPerDataSource',
  EmailRecipientMax = 'EmailRecipientMax',
  EnableUserTracking = 'EnableUserTracking',
  EnhancedNotificationCenter = 'EnhancedNotificationCenter',
  EntryExperience24 = 'EntryExperience24',
  eSignature = 'eSignature',
  FieldCalculations = 'FieldCalculations',
  FileAttachment = 'FileAttachment',
  FileAttachmentMaxFileCount = 'FileAttachmentMaxFileCount',
  FileAttachmentMaxFileSize = 'FileAttachmentMaxFileSize',
  FileManagement = 'FileManagement',
  FieldValidations = 'FieldValidations',
  FormCreatedTrigger = 'FormCreatedTrigger',
  FormJourney = 'FormJourney',
  FormRevert = 'FormRevert',
  FormTransferWorkflow = 'FormTransferWorkflow',
  GoPilot = 'GoPilot',
  GroupTriggers = 'GroupTriggers',
  HideBillingNextButton = 'HideBillingNextButton',
  HierarchicalGroups = 'HierarchicalGroups',
  HIPAASetup = 'HIPAASetup',
  IHRevert = 'IHRevert',
  InactivityTimeout = 'InactivityTimeout',
  InteractiveForms = 'InteractiveForms',
  JobPageRefresh = 'JobPageRefresh',
  ListViewBorderColor = 'ListViewBorderColor',
  ManageSubscription = 'ManageSubscription',
  ManualTrigger = 'ManualTrigger',
  MaskOnComplete = 'MaskOnComplete',
  NamedFunctions = 'NamedFunctions',
  PageElementCheckbox = 'PageElementCheckbox',
  PageElementTable = 'PageElementTable',
  PostPublishPathways = 'PostPublishPathways',
  PostSubmitPublicFormsSurvey = 'PostSubmitPublicFormsSurvey',
  PreviewFeatures = 'PreviewFeatures',
  PublicFormCreditLimit = 'PublicFormCreditLimit',
  PublicFormsPilot = 'PublicFormsPilot',
  PublicFormsSendText = 'PublicFormsSendText',
  PublicFormSubmittedTrigger = 'PublicFormSubmittedTrigger',
  PublicFormV2 = 'PublicFormV2',
  PublicShare = 'PublicShare',
  ReportAccess = 'ReportAccess',
  ReportColumnFiltering = 'ReportColumnFiltering',
  ReportColumnSorting = 'ReportColumnSorting',
  ReportNumberOfTemplates = 'ReportNumberOfTemplates',
  RetainImageAsAttachment = 'RetainImageAsAttachment',
  SavePublicForms = 'SavePublicForms',
  ScheduleTrigger = 'ScheduleTrigger',
  SetDatasourceOffline = 'SetDatasourceOffline',
  ShowCalendlyDuringSurvey = 'ShowCalendlyDuringSurvey',
  SubscriptionUIRefresh = 'SubscriptionUIRefresh',
  TagWorkflow = 'TagWorkflow',
  TemplateEvents = 'TemplateEvents',
  TemplateFieldDateTimeFormat = 'TemplateFieldDateTimeFormat',
  TemplatePublishing = 'TemplatePublishing',
  UsePublicFormCreditLimits = 'UsePublicFormCreditLimits',
  UsersInMultipleGroups = 'UsersInMultipleGroups',
  UserTriggers = 'UserTriggers',
  WebBannerMessage = 'WebBannerMessage',
  Workflow = 'Workflow',
  WorkflowCeaseOnLostPermission = 'WorkflowCeaseOnLostPermission',
  WorkflowRequiredInputs = 'WorkflowRequiredInputs'
}

export const FeatureDefaults = {
  [Features.EmailRecipientMax]: 20
};

/**
 * AppFeatures are for features that are not direct checks for a FeatureFlag.
 *
 * An example would be I want to block access to a page XYZ to only admins or impersonated users.
 *
 * I could make an `AppFeature` that would then have logic bound to it. The logic can include FeatureFlag checks.
 * However if the check is ONLY for a feature flag then just use the canIUse with a feature flag
 */
export enum AppFeatures {
  AddOns = 'AddOns',
  ApiCredentialsUI = 'ApiCredentialsUI',
  BoxIntegration = 'BoxIntegration',
  BulkReRunJobs = 'BulkReRunJobs',
  ConnectedApps = 'ConnectedApps',
  CreateGroups = 'CreateGroups',
  CreateUsers = 'CreateUsers',
  Dashboard = 'Dashboard',
  PremiumPerDataSource = 'PremiumPerDataSource',
  eSignature = 'eSignature',
  FormComplete = 'FormComplete',
  FormCopy = 'FormCopy',
  FormDelete = 'FormDelete',
  FormDeleteDrafts = 'FormDeleteDrafts',
  FormList = 'FormList',
  FormPDF = 'FormPDF',
  FormRename = 'FormRename',
  FormReopen = 'FormReopen',
  FormRevert = 'FormRevert',
  FormTransfer = 'FormTransfer',
  HIPAASetup = 'HIPAASetup',
  LegacyPricing = 'LegacyPricing',
  ManageAutoEmail = 'ManageAutoEmail',
  ManageDataSources = 'ManageDataSources',
  ManageSettings = 'ManageSettings',
  ManageSubscription = 'ManageSubscription',
  ManageUsers = 'ManageUsers',
  ManageUsersAdmin = 'ManageUsersAdmin',
  MessageStatus = 'MessageStatus',
  PreviewFeatures = 'PreviewFeatures',
  ProfileNotifications = 'ProfileNotifications',
  PublicShare = 'PublicShare',
  PublicShareBuyCredits = 'PublicShareBuyCredits',
  PublicFormCreditLimits = 'PublicFormCreditLimits',
  PublicFormCreditLimitsTrial = 'PublicFormCreditLimitsTrial',
  Reports = 'Reports',
  RetainImageAsAttachment = 'RetainImageAsAttachment',
  TagAdd = 'TagAdd',
  TagCreate = 'TagCreate',
  TagManage = 'TagManage',
  TagModal = 'TagModal',
  TakeOwnership = 'TakeOwnership',
  TemplateEditorJson = 'TemplateEditorJson',
  TemplateList = 'TemplateList',
  TemplateFolders = 'TemplateFolders',
  WebhooksUI = 'WebhooksUI',
  Workflow = 'Workflow',
  WorkflowJson = 'WorkflowJson'
}
